import * as React from 'react';

function SvgArrowBackIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.754 17.204a.916.916 0 00.117-1.29l-3.33-3.997h10.876a.917.917 0 000-1.833H6.54l3.33-3.997a.916.916 0 10-1.408-1.173l-4.583 5.5c-.037.043-.055.094-.082.142-.022.037-.048.07-.064.112a.91.91 0 00-.067.332c0 .114.025.226.067.333.016.041.042.074.064.112.027.047.045.099.082.142l4.583 5.5a.916.916 0 001.29.117z"
        fill="#18379A"
      />
    </svg>
  );
}

export default SvgArrowBackIcon;
